/**
 * Tiny Vietnamese relative-time formatter. Sufficient for "updated 3 ngày trước"
 * style labels on property cards — swap for `Intl.RelativeTimeFormat("vi")` if
 * we ever need full locale support.
 */
export function formatRelativeVi(iso: string | null, now: Date = new Date()): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const diffSec = Math.max(0, Math.round((now.getTime() - then) / 1000));

  if (diffSec < 60) return "vừa xong";
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin} phút trước`;
  const diffHour = Math.round(diffMin / 60);
  if (diffHour < 24) return `${diffHour} giờ trước`;
  const diffDay = Math.round(diffHour / 24);
  if (diffDay < 30) return `${diffDay} ngày trước`;
  const diffMonth = Math.round(diffDay / 30);
  if (diffMonth < 12) return `${diffMonth} tháng trước`;
  const diffYear = Math.round(diffMonth / 12);
  return `${diffYear} năm trước`;
}
